// Mint-HS: dữ liệu mẫu + logic chọn mã / thuế / FTA (chép từ script board). Chỉ đọc, không gọi mạng, không hiện tiền.

export type Dir = 'NK' | 'XK';
export const ORIGINS: Record<Dir, string[]> = {
  NK: ['Trung Quốc', 'Hàn Quốc', 'Nhật Bản', 'Thái Lan', 'Đức (EU)', 'Malaysia'],
  XK: ['Hoa Kỳ', 'Nhật Bản', 'Hàn Quốc', 'Đức (EU)', 'Úc', 'Canada'],
};
export const CANDS: [string, string, number, string][] = [
  ['8516.71.00', 'Dụng cụ pha chè hoặc cà phê, dùng điện', 92, 'Máy pha cà phê gia dụng 1.450W, đun nước bằng điện trở → nhóm 85.16 (thiết bị nhiệt điện gia dụng), phân nhóm 8516.71 đích danh “coffee or tea makers”. Quy tắc 1 và 6.'],
  ['8516.79.90', 'Thiết bị nhiệt điện gia dụng khác', 5, 'Mã khách gợi ý. Chỉ dùng khi hàng không có chức năng pha (ví dụ chỉ đun nước). Mô tả có “tự động xay & pha” nên loại.'],
  ['8419.81.10', 'Máy pha cà phê, đun nóng thức ăn — dùng trong thương mại', 3, 'Chỉ khi là máy công nghiệp/quán (không dùng điện gia dụng hoặc công suất lớn). Công suất 1.450W, bán lẻ → không thuộc.'],
];
// [NKTT, MFN, VAT, TTĐB, XK, BVMT]
export const TAX: string[][] = [
  ['37,5%', '25%', '10%', '0%', '0%', '—'],
  ['30%', '20%', '10%', '0%', '0%', '—'],
  ['7,5%', '5%', '10%', '0%', '0%', '—'],
];
const FTA: [string, string, string[], number[], string][] = [
  ['ACFTA', 'E', ['Trung Quốc'], [0, 5, 0], 'RVC 40%'],
  ['ATIGA', 'D', ['Thái Lan', 'Malaysia'], [0, 0, 0], 'RVC 40% hoặc CTH'],
  ['AKFTA', 'AK', ['Hàn Quốc'], [0, 5, 0], 'RVC 40% hoặc CTH'],
  ['VKFTA', 'VK', ['Hàn Quốc'], [0, 0, 0], 'RVC 40% hoặc CTH'],
  ['AJCEP', 'AJ', ['Nhật Bản'], [5, 5, 0], 'RVC 40% hoặc CTH'],
  ['VJEPA', 'VJ', ['Nhật Bản'], [0, 3, 0], 'RVC 40% hoặc CTH'],
  ['CPTPP', 'CPTPP / tự chứng nhận', ['Nhật Bản', 'Malaysia', 'Úc', 'Canada'], [3, 3, 0], 'CTSH hoặc RVC 45%'],
  ['EVFTA', 'EUR.1 / REX', ['Đức (EU)'], [4, 4, 0], 'MaxNOM 50% EXW'],
  ['RCEP', 'RCEP', ['Trung Quốc', 'Hàn Quốc', 'Nhật Bản', 'Thái Lan', 'Malaysia', 'Úc'], [8, 10, 0], 'RVC 40% hoặc CTH'],
];

export interface FtaRow { k: string; form: string; rate: string; rule: string; ok: boolean; best: boolean; s: string }
export function ftaTable(origin: string, pick: number): { rows: FtaRow[]; bestK: string } {
  const all = FTA.map(([k, form, ori, rates, rule]) => ({ k, form, ok: ori.includes(origin), r: rates[pick]!, rule }));
  const best = all.filter((f) => f.ok).sort((a, b) => a.r - b.r)[0];
  const mfn = parseFloat(TAX[pick]![1]!);
  const rows = all
    .slice()
    .sort((a, b) => Number(b.ok) - Number(a.ok) || a.r - b.r)
    .map((f) => {
      const isBest = !!best && f.k === best.k;
      return { k: f.k, form: f.form, rate: `${f.r}%`, rule: f.rule, ok: f.ok, best: isBest, s: !f.ok ? 'không áp dụng · xuất xứ khác' : isBest ? `Tốt nhất · dùng C/O ${f.form.split(' ')[0]}` : f.r < mfn ? 'Áp dụng được' : 'Không lợi hơn MFN' };
    });
  return { rows, bestK: best ? `Dùng C/O form ${best.form.split(' ')[0]} · ${best.r}%` : 'Không có FTA áp dụng' };
}

export function taxCards(pick: number, origin: string): { k: string; v: string; s: string; hi: boolean }[] {
  const T = TAX[pick]!;
  const { rows } = ftaTable(origin, pick);
  const b = rows.find((r) => r.best);
  return ([
    ['NK thông thường', T[0]!, '150% MFN'],
    ['NK ưu đãi (MFN)', T[1]!, 'có C/O hoặc không'],
    ['Ưu đãi đặc biệt', b ? b.rate : '—', b ? `${b.k} · form ${b.form.split(' ')[0]}` : 'không có FTA'],
    ['VAT', T[2]!, 'trên trị giá + thuế NK'],
    ['TTĐB', T[3]!, 'không thuộc diện'],
    ['Xuất khẩu', T[4]!, 'không thuộc biểu XK'],
    ['BVMT', T[5]!, 'không thuộc diện'],
    ['Chống bán phá giá', '—', 'không có biện pháp'],
  ] as [string, string, string][]).map(([k, v, s], i) => ({ k, v, s, hi: i === 2 && !!b }));
}

export const POLICY: [string, 'warn' | 'ok'][][] = [
  [['Kiểm tra chất lượng nhà nước trước thông quan · QCVN 4:2009/BKHCN (an toàn điện)', 'warn'], ['Tương thích điện từ QCVN 9:2012/BKHCN · cần giấy đăng ký kiểm tra', 'warn'], ['Không thuộc danh mục cấm / giấy phép · dán nhãn hàng hoá theo NĐ 43/2017', 'ok']],
  [['Kiểm tra chất lượng theo QCVN 4:2009/BKHCN', 'warn'], ['Không thuộc danh mục cấm', 'ok']],
  [['Kiểm tra chất lượng theo QCVN 4:2009/BKHCN', 'warn'], ['Không thuộc danh mục cấm', 'ok']],
];

export const RECENT: [string, string, string, string, 'warn' | 'ok' | 'err' | 'info'][] = [
  ['8516.71.00', 'Máy pha cà phê tự động 1.450W', 'VINAVARIETY · đang tra', 'Chờ xác nhận', 'warn'],
  ['9403.60.90', 'Tủ bếp gỗ cao su lắp ráp', 'VINAVARIETY · 21/Oct/2026', 'Đã xác nhận', 'ok'],
  ['0901.21.20', 'Cà phê rang xay đóng gói 500g', 'GREENBUD · 20/Oct/2026', 'Đã xác nhận', 'ok'],
  ['6006.22.00', 'Vải dệt kim sợi bông đã nhuộm', 'COCOGROUP · 19/Oct/2026', 'Đã xác nhận', 'ok'],
  ['3923.21.99', 'Túi PE in logo', 'SAVITA · 18/Oct/2026', 'Trả lại', 'err'],
  ['6911.10.00', 'Bộ ấm chén sứ', 'TAMNGOC · 17/Oct/2026', 'Đã xác nhận', 'ok'],
];
export const PEND: typeof RECENT = [
  ['8516.71.00', 'Máy pha cà phê tự động 1.450W', 'NHIDTT · hạn 23/Oct/2026 11:00', 'còn 6h', 'warn'],
  ['8471.30.20', 'Máy tính bảng 10 inch', 'HOATTN · BAOANVISION · hạn 23/Oct/2026 16:00', 'còn 11h', 'info'],
  ['0306.17.11', 'Tôm thẻ đông lạnh nguyên con', 'NHIDTT · THANHHAO · hạn 22/Oct/2026 15:00', 'trễ 1h', 'err'],
];
export const JOBS: [string, string][] = [
  ['SI260639810', 'Nhập · SGN ← SHA · ETA 28/Oct/2026'],
  ['SI260640050', 'Nhập · CLI ← BUS · ETA 02/Nov/2026'],
  ['AI260640130', 'Nhập · SGN ← NRT · ETA 25/Oct/2026'],
];
export const DESC0 = 'Máy pha cà phê tự động, xay & pha espresso, điện 220V 1.450W, bình 1,8L, vỏ nhựa ABS + thép không gỉ, dùng gia đình. Đóng thùng carton 1 bộ/thùng.';
